import { baseForPdf } from '../apiClients';
import { Endpoints } from '../../network';

export const getAllBannerPages = async () => {
  const response = await baseForPdf.get(Endpoints.allBannerPages);
  return response?.data;
};

export const getAllBanners = async (pageId: string) => {
  const response = await baseForPdf.get(`${Endpoints.allBanners}/${pageId}`);
  return response?.data;
};

export const getBannersByRoute = async (route: string) => {
  const response = await baseForPdf.get(
    `${Endpoints.getBannersByRoute}?route=${encodeURIComponent(route)}`,
  );
  return response?.data;
};
